import React from 'react';

const Heading = () => {
  return (
    <React.Fragment>
      <h2 className=' text-white text-3xl font-extrabold leading-relaxed md:leading-relaxed xl:leading-relaxed'>
        Check how much you can earn
      </h2>
      <p className='text-textLight font-extralight text-base leading-relaxed 2xl:leading-relaxed mt-8 mb-16 max-w-2xl mx-auto'>
        Let’s check your hash rate to see how much you will earn today,
        Exercitation veniam consequat sunt nostrud amet.
      </p>
    </React.Fragment>
  );
};

export default Heading;
